import { Link } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function SiteFooter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're on the list. Welcome to Morning Soft.");
      setEmail("");
    } catch {
      toast.error("Please enter a valid email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-[#0f2a5c] text-white mt-20" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src="/products/img_10.png" alt="Morning Soft" className="h-14 w-14 bg-white/10 rounded-full p-1" />
            <div>
              <p className="font-display text-2xl font-extrabold">
                Morning<span className="text-amber-400">Soft</span><sup className="text-xs">®</sup>
              </p>
              <p className="text-xs uppercase tracking-widest text-sky-200 mt-1">Everyday Premium™</p>
            </div>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-sky-100/80 max-w-md">
            Softness you can feel. Quality you can trust. A U.S.-based household paper &
            personal-care brand building the future of everyday comfort.
          </p>
          <form onSubmit={submit} noValidate className="mt-6 flex max-w-md" data-testid="footer-newsletter-form">
            <input
              data-testid="footer-newsletter-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email"
              className="flex-1 px-4 py-3 rounded-l-full bg-white/10 border border-white/10 text-white placeholder-sky-200/60 text-sm focus:outline-none focus:border-amber-400"
            />
            <button
              data-testid="footer-newsletter-submit"
              disabled={loading}
              className="px-5 py-3 rounded-r-full bg-amber-400 text-[#0f2a5c] font-bold text-sm hover:bg-amber-300 disabled:opacity-60"
            >
              {loading ? "…" : "Join"}
            </button>
          </form>
        </div>

        <div>
          <p className="text-xs uppercase tracking-widest text-amber-400 font-bold mb-4">Shop</p>
          <ul className="space-y-2.5 text-sm text-sky-100/85">
            <li><Link to="/shop?category=bathroom-tissue">Bathroom Tissue</Link></li>
            <li><Link to="/shop?category=kitchen-towel">Kitchen Towels</Link></li>
            <li><Link to="/shop?category=facial-tissue">Facial Tissue</Link></li>
            <li><Link to="/shop?category=wipes">Wipes</Link></li>
            <li><Link to="/shop?category=hygiene">Hygiene & Care</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-xs uppercase tracking-widest text-amber-400 font-bold mb-4">Company</p>
          <ul className="space-y-2.5 text-sm text-sky-100/85">
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><a href="mailto:sales@morningsofttissue.com">sales@morningsofttissue.com</a></li>
            <li>Morning Soft LLC</li>
            <li>Angleton, Texas 77515</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-sky-200/60">
          <p>© {new Date().getFullYear()} Morning Soft LLC. All Rights Reserved.</p>
          <p>www.morningsofttissue.com · Start Your Day in Comfort.</p>
        </div>
      </div>
    </footer>
  );
}
